import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=797e31be&scoped=true&"
import script from "./Navbar.vue?vue&type=script&lang=js&"
export * from "./Navbar.vue?vue&type=script&lang=js&"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=797e31be&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./Navbar.vue?vue&type=style&index=1&id=797e31be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797e31be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('797e31be')) {
      api.createRecord('797e31be', component.options)
    } else {
      api.reload('797e31be', component.options)
    }
    module.hot.accept("./Navbar.vue?vue&type=template&id=797e31be&scoped=true&", function () {
      api.rerender('797e31be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/Navbar.vue"
export default component.exports